export const updateReference = (name, value) => ({
    type: 'UPDATE_REFERENCE',
    payload: { name, value },
});

export const setReference = (data) => ({
    type: 'SET_REFERENCE',
    payload: data,
});

export const clearReference = () => ({
    type: 'CLEAR_REFERENCE',
});

export const loadReference = (data) => ({
    type: 'LOAD_REFERENCE',
    payload: data,
});

export const updateCaracConvoi = (name, value) => ({
    type: 'UPDATE_CARAC_CONVOI',
    payload: { name, value },
});

export const clearCaracConvoi = () => ({
    type: 'CLEAR_CARAC_CONVOI',
});

export const loadCaracConvoi = (data) => ({
    type: 'LOAD_CARAC_CONVOI',
    payload: data,
});

export const updateInfosCompl = (name, value) => ({
    type: 'UPDATE_INFOS_COMPL',
    payload: { name, value },
});

export const clearInfosCompl = () => ({
    type: 'CLEAR_INFOS_COMPL',
});

export const loadInfosCompl = (data) => ({
    type: 'LOAD_INFOS_COMPL',
    payload: data,
});


export const updateTrajetDescr = (name, value) => ({
    type: 'UPDATE_TRAJET_DESCR',
    payload: { name, value },
});

export const clearTrajetDescr = () => ({
    type: 'CLEAR_TRAJET_DESCR',
});

export const loadTrajetDescr = (data) => ({
    type: 'LOAD_TRAJET_DESCR',
    payload: data,
});